import React from 'react';
import { View, VStack, HStack, Text, Box } from 'native-base';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/solid';

import { Image } from 'expo-image';
import { AppData } from '@breakroom-nx/helpers';
import { theme } from '@breakroom-nx/assets';
import logo from '../../../../assets/src/images/alpha-logo.webp';
import icon from '../../../../assets/src/images/icon.webp';
import { IconButton, Ring, SearchBar } from '../..';
import {
  useAppDispatch,
  useAppSelector,
  toggleFeedbackPanel,
  getDevice,
  useGetAppUpdatesQuery,
  useGetAppMetadataQuery,
  getFeedbackPanelState,
} from '@breakroom-nx/redux';

export function AppInfo() {
  const dispatch = useAppDispatch();
  const panelOpen = useAppSelector(getFeedbackPanelState);
  const mobileDevice = useAppSelector(getDevice);
  const { data: metadata, isLoading } = useGetAppMetadataQuery(null);
  const { data: unreadUpdates } = useGetAppUpdatesQuery();

  return (
    <HStack
      maxWidth={'full'}
      flexWrap={'wrap'}
      flexDirection={'row'}
      space={2}
      alignItems={'start'}
      paddingX={{ base: 3, lg: 10 }}
      paddingTop={{ base: 1, lg: 10 }}
    >
      <HStack
        space={2}
        width={mobileDevice ? 'full' : 'auto'}
        justifyContent={mobileDevice ? 'space-between' : 'normal'}
      >
        <HStack alignItems={'center'} space={2}>
          <Box
            height={{
              base: '35px',
              lg: '50px',
            }}
            width={{
              base: '35px',
              lg: '50px',
            }}
          >
            <Image
              source={icon}
              cachePolicy={'memory-disk'}
              accessibilityLabel={`${AppData.APP_NAME} logo`}
              contentFit={'contain'}
              style={{
                height: '100%',
                width: '100%',
              }}
            />
          </Box>
          <VStack alignItems={'flex-start'}>
            <Box
              height={{ base: '22px', lg: '44px' }}
              width={{ base: '90px', lg: '180px' }}
            >
              <Image
                source={logo}
                cachePolicy={'memory-disk'}
                accessibilityLabel={`${AppData.APP_NAME} logo`}
                contentFit={'contain'}
                style={{
                  height: '100%',
                  width: '100%',
                }}
              />
            </Box>
            {!isLoading && (
              <Text
                fontWeight={400}
                color={'surface.600'}
                fontSize={{ base: '10px', lg: '16px' }}
              >
                {`v${metadata?.version ?? '1.0.0'}`}
              </Text>
            )}
          </VStack>
        </HStack>

        <Ring hidden={!panelOpen}>
          <IconButton
            onPress={() => {
              dispatch(toggleFeedbackPanel());
            }}
            icon={
              <WrenchScrewdriverIcon
                style={{
                  height: '20px',
                  width: '20px',
                  color: theme.colors.primary[400],
                }}
              />
            }
            tooltipText={'Updates and Feedback'}
            badgeNumber={unreadUpdates?.length ?? 0}
          />
        </Ring>
      </HStack>
      <VStack paddingTop={{ lg: 2.5}} width={mobileDevice ? 'full' : 'auto'}>
        <SearchBar />
      </VStack>
    </HStack>
  );
}

export default React.memo(AppInfo);
